(function() {
  if (window.location.pathname.indexOf('/products/') === -1) return;

  function findBtn() {
    return document.querySelector('[name="add"]') ||
           document.querySelector('button.product-form__submit') ||
           document.querySelector('.product-form__buttons button[type="submit"]') ||
           document.querySelector('.product-form__buttons button') ||
           document.querySelector('product-form button[type="submit"]') ||
           document.querySelector('product-form button') ||
           document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
           document.querySelector('form[action*="/cart/add"] button');
  }

  function findForm() {
    return document.querySelector('product-form form') ||
           document.querySelector('form[action*="/cart/add"]');
  }

  function run(attempts) {
    attempts = attempts || 0;
    var form = findForm();
    var btn = findBtn();
    if (!btn && attempts < 40) return setTimeout(function() { run(attempts + 1); }, 300);
    if (!btn) { console.log('KARAR: gave up finding button'); return; }
    if (document.getElementById('karar-atc-bar')) return;
    buildBar(form, btn);
  }

  function buildBar(form, btn) {
    var bar = document.createElement('div');
    bar.id = 'karar-atc-bar';
    bar.style.cssText = 'position:fixed!important;bottom:0!important;left:0!important;right:0!important;z-index:2147483647!important;background:#fff!important;border-top:2px solid #111!important;box-shadow:0 -4px 20px rgba(0,0,0,.18)!important;padding:8px 12px calc(8px + env(safe-area-inset-bottom))!important;display:flex!important;flex-direction:column!important;gap:6px!important;max-height:38vh!important;overflow-y:auto!important;';

    var title = document.querySelector('.product__title h1');
    var img = document.querySelector('.product__media-item img');
    var qty = 1;

    // ROW 1: thumb + title/price + ATC BUTTON (always visible)
    var top = document.createElement('div');
    top.style.cssText = 'display:flex!important;align-items:center!important;gap:8px!important;';

    if (img) {
      var im = document.createElement('img');
      im.src = img.src;
      im.style.cssText = 'width:44px!important;height:44px!important;border-radius:6px!important;object-fit:cover!important;flex-shrink:0!important;';
      top.appendChild(im);
    }

    var meta = document.createElement('div');
    meta.style.cssText = 'flex:1!important;min-width:0!important;';
    var ne = document.createElement('div');
    ne.style.cssText = 'font-size:11px!important;font-weight:600!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important;color:#111!important;line-height:1.2!important;';
    ne.textContent = title ? title.textContent.trim() : '';
    var pe = document.createElement('div');
    pe.id = 'katc-price';
    pe.style.cssText = 'font-size:15px!important;font-weight:800!important;color:#111!important;line-height:1.2!important;margin-top:2px!important;';
    var pEl = document.querySelector('.price .price-item--regular');
    pe.textContent = pEl ? pEl.textContent.trim() : '';
    meta.appendChild(ne); meta.appendChild(pe);
    top.appendChild(meta);

    // ATC BUTTON — in top row, always visible
    var ab = document.createElement('button');
    ab.type = 'button'; ab.id = 'katc-btn';
    var sp = btn.querySelector('span:first-child');
    ab.textContent = (sp && sp.textContent.trim()) ? sp.textContent.trim() : (btn.textContent.trim() || 'Add to Cart');
    ab.style.cssText = 'background:#111!important;color:#fff!important;border:none!important;border-radius:8px!important;padding:12px 18px!important;font-size:13px!important;font-weight:700!important;cursor:pointer!important;font-family:inherit!important;flex-shrink:0!important;white-space:nowrap!important;text-transform:uppercase!important;letter-spacing:0.5px!important;box-shadow:0 2px 6px rgba(0,0,0,0.25)!important;';

    ab.addEventListener('click', function() {
      var qi = form ? form.querySelector('[name="quantity"]') : null;
      if (qi) qi.value = qty;
      btn.scrollIntoView({block:'center'});
      btn.click();
    });

    top.appendChild(ab);
    bar.appendChild(top);

    // ROW 2: variant pills (compact)
    document.querySelectorAll('variant-radios fieldset').forEach(function(fs) {
      var row = document.createElement('div');
      row.style.cssText = 'display:flex!important;align-items:center!important;gap:6px!important;flex-wrap:wrap!important;';
      var leg = fs.querySelector('legend');
      if (leg) {
        var l = document.createElement('span');
        l.style.cssText = 'font-size:9px!important;font-weight:700!important;text-transform:uppercase!important;color:#999!important;min-width:40px!important;';
        l.textContent = leg.childNodes[0] ? leg.childNodes[0].textContent.trim() : '';
        row.appendChild(l);
      }
      var pw = document.createElement('div');
      pw.style.cssText = 'display:flex!important;flex-wrap:wrap!important;gap:4px!important;';
      fs.querySelectorAll('input[type="radio"]').forEach(function(inp) {
        var p = document.createElement('button');
        p.type = 'button'; p.textContent = inp.value;
        var a = inp.checked;
        p.style.cssText = 'border:1.5px solid '+(a?'#111':'#ccc')+'!important;background:'+(a?'#111':'#fff')+'!important;color:'+(a?'#fff':'#111')+'!important;border-radius:5px!important;padding:3px 9px!important;font-size:10px!important;font-weight:600!important;cursor:pointer!important;font-family:inherit!important;';
        p.addEventListener('click', function() {
          pw.querySelectorAll('button').forEach(function(b) { b.style.background='#fff'; b.style.color='#111'; b.style.borderColor='#ccc'; });
          p.style.background='#111'; p.style.color='#fff'; p.style.borderColor='#111';
          fs.querySelectorAll('input[type="radio"]').forEach(function(r) {
            if (r.value === inp.value) { r.checked = true; r.dispatchEvent(new Event('change', {bubbles:true})); }
          });
        });
        pw.appendChild(p);
      });
      row.appendChild(pw); bar.appendChild(row);
    });

    document.body.appendChild(bar);
    document.body.style.paddingBottom = '140px';
    console.log('KARAR: sticky bar with ATC built successfully');

    // Sync disabled state
    new MutationObserver(function() {
      var b = document.getElementById('katc-btn'); if (!b) return;
      b.disabled = btn.disabled;
      var s = btn.querySelector('span:first-child');
      var txt = s ? s.textContent.trim() : btn.textContent.trim();
      if (txt) b.textContent = txt;
      // Also fade if sold out
      b.style.opacity = btn.disabled ? '0.5' : '1';
      b.style.cursor = btn.disabled ? 'not-allowed' : 'pointer';
    }).observe(btn, {attributes:true, childList:true, subtree:true});

    // Price on variant change
    document.addEventListener('variant:changed', function(e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var p = document.getElementById('katc-price');
      if (p && v.price) p.textContent = 'Rs. ' + Math.round(v.price/100).toLocaleString();
    });

    // Show/hide on scroll
    function check() {
      var r = btn.getBoundingClientRect();
      var visible = r.top >= 0 && r.bottom <= window.innerHeight;
      bar.style.display = visible ? 'none' : 'flex';
      bar.style.flexDirection = 'column';
    }
    window.addEventListener('scroll', check, {passive:true});
    check();
  }

  if (document.readyState === 'complete') {
    setTimeout(function() { run(0); }, 1000);
  } else {
    window.addEventListener('load', function() {
      setTimeout(function() { run(0); }, 1000);
    });
  }

})();
